enum ProcessTypeEnum {
  Production,
  Testing,
  Print,
  Picking,
  FollowUpPicking,
  LedCut,
  LedLength
}

export default ProcessTypeEnum;
